import { api } from '../../lib/spizirnaUi';

/**
 * Pořadí kategorií (2026-10-27) — jedno pro pokladnu, kiosek i e-shop.
 *
 * Kategorie se řadí jen mezi sourozenci. Přesun nad/pod kategorii z jiné
 * úrovně ji nejdřív přesune pod stejného rodiče (PUT parent_id — server hlídá
 * hloubku a cykly), pak se celá úroveň přečísluje po desítkách.
 */

/** Sourozenci kategorie (včetně ní) v pořadí stromu a id jejich rodiče. */
export function sourozenci(strom, id) {
    const hledej = (uzly, rodic) => {
        for (const n of uzly) {
            // stejně jako strom: podle pořadí, při shodě podle názvu
            if (n.id === id) return { seznam: [...uzly].sort((x, y) => (x.poradi ?? 0) - (y.poradi ?? 0) || (x.nazev || '').localeCompare(y.nazev || '', 'cs')), rodicId: rodic };
            const v = hledej(n.children || [], n.id);
            if (v) return v;
        }
        return null;
    };
    return hledej(strom || [], null);
}

const jePotomek = (strom, predekId, id) => {
    const najdi = (uzly) => { for (const n of uzly) { if (n.id === predekId) return n; const v = najdi(n.children || []); if (v) return v; } return null; };
    const predek = najdi(strom || []);
    const vPodstromu = (n) => (n.children || []).some((c) => c.id === id || vPodstromu(c));
    return predek ? vPodstromu(predek) : false;
};

/**
 * Přesune kategorii `srcId` nad nebo pod `cilId` (poloha 'nad' | 'pod').
 * Vrací Promise; chyba serveru (např. hloubka) se vyhodí s textem.
 */
export async function presunKategorii(strom, srcId, cilId, poloha) {
    if (srcId === cilId || jePotomek(strom, srcId, cilId)) return;
    const cil = sourozenci(strom, cilId);
    const zdroj = sourozenci(strom, srcId);
    if (!cil || !zdroj) return;

    if (zdroj.rodicId !== cil.rodicId) {
        await api(`/api/recepty/kategorie-surovin/${srcId}`, 'PUT', { parent_id: cil.rodicId });
    }

    const posunuty = zdroj.seznam.find((n) => n.id === srcId);
    const seznam = cil.seznam.filter((n) => n.id !== srcId);
    const i = seznam.findIndex((n) => n.id === cilId);
    seznam.splice(poloha === 'nad' ? i : i + 1, 0, posunuty);
    const hloubka = cil.seznam.find((n) => n.id === cilId)?.hloubka ?? 0;

    await api('/api/recepty/kategorie-surovin/reorder', 'POST', {
        polozky: seznam.map((n, j) => ({ id: n.id, parent_id: cil.rodicId, poradi: (j + 1) * 10, hloubka })),
    });
}

/** Posun o jedno místo mezi sourozenci (smer -1 = výš, +1 = níž). */
export async function posunKategorii(strom, id, smer) {
    const s = sourozenci(strom, id);
    if (!s) return;
    const i = s.seznam.findIndex((n) => n.id === id);
    const soused = s.seznam[i + smer];
    if (!soused) return;
    await presunKategorii(strom, id, soused.id, smer < 0 ? 'nad' : 'pod');
}
